import { useIntl } from 'react-intl';

import expandDescription from '../../../../assets/svg/expandDescription.svg';
import darkExpandDescription from '../../../../assets/svg/expandDescriptionDark.svg';
import FunctionButton from '../../../common/functionButton';

interface ExpandButtonProps {
  handleButtonClicked: () => void;
  variant?: string;
}

const ExpandButton = ({ handleButtonClicked, variant }: ExpandButtonProps) => {
  const intl = useIntl();
  return (
    <FunctionButton
      text={intl.formatMessage({ defaultMessage: 'Expand' })}
      handleButtonClicked={handleButtonClicked}
      icon={variant === 'dark' ? darkExpandDescription : expandDescription}
      customVariant={variant}
    />
  );
};

export default ExpandButton;
